angular.module('PestDiseaseApp').factory("MonitorSummaryFactory", ["$resource", function ($resource) {
    return $resource('/api/decision-support/pest-disease/summary/', {}, {
        query: {
            isArray: true
        }
    });
}]);
